/**
 * Správce ztotožnění subjektu
 */
class ZtotozneniManager {
	/**
	 * Konstruktor
	 */
	constructor() {
		// this.lastAifoValue = $("input[name='aifo']").val();
		this.fieldComparators = new Map();
	}

	/**
	 * Porovná hodnotu pole s poslední známou hodnotou
	 * @param el
	 * @param lastValue
	 * @param alertElement
	 */
	compareValueWithLast(el, lastValue, alertElement = null) {
		let currentValue = $(el).val();
		if (currentValue !== lastValue) {
			$(el).addClass('border-warning');
			if (alertElement) {
				alertElement.show();
			}
		} else {
			$(el).removeClass('border-warning');
			if (alertElement) {
				alertElement.hide();
			}
		}
	}

	/**
	 * Nastaví zvýraznění referenčního pole
	 * @param fieldName
	 * @param state
	 */
	setRefElement(fieldName, state = true) {
		let element = $(fieldName);
		if (state) {
			element.css({
				'border': '2px solid rgba(0,123,255,0.5)',
				'box-shadow': '0 0 3px rgba(0,123,255,0.25)'
			});
		} else {
			element.css({
				'border': '',
				'box-shadow': ''
			});
		}
	}

	/**
	 * Přidá porovnávací funkci k poli formuláře
	 * @param fieldName
	 * @param alertClass
	 */
	addFieldComparator(fieldName, alertClass) {
		let element = $(fieldName);
		let lastValue = element.val();
		element.on("keyup", () => {
			this.compareValueWithLast(element, lastValue, $(alertClass));
		});
	}

	/**
	 * Inicializace podle typu subjektu
	 * @param type
	 * @param agenda
	 */
	initForType(type, agenda = null) {
		switch (type) {
			case 'FO':
				this.initFO(agenda);
				break;
			case 'PFO':
				this.initPFO(agenda);
				break;
			case 'PO':
				this.initPO(agenda);
				break;
		}
	}

	/**
	 * Inicializace pro FO
	 * @param agenda
	 */
	initFO(agenda = null) {
		if (['ros', 'rob'].includes(agenda.toLowerCase())) {
			this.addFieldComparator("input[name='dss\\[0\\]']", ".compareDss");
			this.addFieldComparator("input[name='datum_narozeni']", ".compareDatumNarozeni");
			this.addFieldComparator("input[name='jmeno']", ".compareJmeno");
			this.addFieldComparator("input[name='prijmeni']", ".comparePrijmeni");
			this.addFieldComparator("input[name='kod_adresniho_mista']", ".compareKodAdresa");

			this.setRefElement("input[name='dss\\[0\\]']");
			this.setRefElement("input[name='datum_narozeni']");
			this.setRefElement("input[name='jmeno']");
			this.setRefElement("input[name='prijmeni']");
			this.setRefElement("input[name='kod_adresniho_mista']");
		} else if (agenda && agenda.toLowerCase() === 'isds') {
			// this.initISDS(agenda);
		}
	}

	/**
	 * Inicializace pro PFO
	 * @param agenda
	 */
	initPFO(agenda = null) {
		if (['ros', 'rob'].includes(agenda.toLowerCase())) {
			this.addFieldComparator("input[name='ic']", ".compareIc");
			this.addFieldComparator("input[name='dss\\[0\\]']", ".compareDss");
			this.addFieldComparator("select[name='pravni_forma']", ".compareForm");
			this.addFieldComparator("input[name='jmeno']", ".compareJmeno");
			this.addFieldComparator("input[name='prijmeni']", ".comparePrijmeni");
			this.addFieldComparator("input[name='datum_narozeni']", ".compareDatumNarozeni");
			this.addFieldComparator("input[name='nazev_subjektu']", ".compareNazev");
			this.addFieldComparator("input[name='firma_kod_adresniho_mista']", ".compareKodAdresa");

			this.setRefElement("input[name='ic']");
			this.setRefElement("input[name='dss\\[0\\]']");
			this.setRefElement("select[name='pravni_forma']");
			this.setRefElement("input[name='jmeno']");
			this.setRefElement("input[name='prijmeni']");
			this.setRefElement("input[name='datum_narozeni']");
			this.setRefElement("input[name='nazev_subjektu']");
			this.setRefElement("input[name='firma_kod_adresniho_mista']");
		} else if (agenda && agenda.toLowerCase() === 'isds') {
			// this.initISDS(agenda);
		}
	}

	/**
	 * Inicializace pro PO
	 * @param agenda
	 */
	initPO(agenda = null) {
		if (['ros', 'rob'].includes(agenda.toLowerCase())) {
			this.addFieldComparator("input[name='ic']", ".compareIc");
			this.addFieldComparator("input[name='dss\\[0\\]']", ".compareDss");
			this.addFieldComparator("select[name='pravni_forma']", ".compareForm");
			this.addFieldComparator("input[name='nazev_subjektu']", ".compareNazev");

			this.setRefElement("input[name='ic']");
			this.setRefElement("input[name='dss\\[0\\]']");
			this.setRefElement("select[name='pravni_forma']");
			this.setRefElement("input[name='nazev_subjektu']");
		} else if (agenda && agenda.toLowerCase() === 'isds') {
			// this.initISDS(agenda);
		}
	}

	/**
	 * Inicializace pro ISDS
	 * @param agenda
	 */
	initISDS(agenda = null) {
		this.setRefElement("input[name='dss\\[0\\]']");
		this.setRefElement("input[name='ic']");
		this.setRefElement("input[name='jmeno']");
		this.setRefElement("input[name='prijmeni']");
		this.setRefElement("input[name='prostredni_jmeno']");
		this.setRefElement("input[name='rodne_prijmeni']");
		this.setRefElement("input[name='nazev_subjektu']");
		this.setRefElement("input[name='datum_narozeni']");
		this.setRefElement("input[name='misto_narozeni']");
		this.setRefElement("input[name='okres_narozeni']");
		this.setRefElement("select[name='stat_narozeni']");
		this.setRefElement("input[name='adresa_ulice']");
		this.setRefElement("input[name='firma_adresa_ulice']");
		this.setRefElement("input[name='adresa_mesto']");
		this.setRefElement("input[name='firma_adresa_mesto']");
		this.setRefElement("input[name='adresa_cp']");
		this.setRefElement("input[name='firma_adresa_cp']");
		this.setRefElement("input[name='adresa_co']");
		this.setRefElement("input[name='firma_adresa_co']");
		this.setRefElement("input[name='adresa_psc']");
		this.setRefElement("input[name='firma_adresa_psc']");
		this.setRefElement("select[name='adresa_stat']");
		this.setRefElement("select[name='firma_adresa_stat']");
		this.setRefElement("input[name^='emails[']");
		this.setRefElement("input[name='telefon']");
		this.setRefElement("input[name='ovm']");
	}
}
